import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const lngs = [
  { value: 'it', label: 'ITA', icon: 'it.svg' },
  { value: 'en', label: 'ENG', icon: 'it.svg' },
  // { value: 'fr', label: 'FRA', icon: 'it.svg' }
];

/* eslint-disable */
class IconOption extends Component {
  handleMouseDown = (event) => {
		event.preventDefault();
		event.stopPropagation();
		this.props.onSelect(this.props.option, event);
	};

	handleMouseEnter = (event) => {
		this.props.onFocus(this.props.option, event);
	};

	handleMouseMove = (event) => {
		if (this.props.isFocused) return;
		this.props.onFocus(this.props.option, event);
	};

  render() {
    return (
      <div
      className={this.props.className}
      onMouseDown={this.handleMouseDown}
      onMouseEnter={this.handleMouseEnter}
      onMouseMove={this.handleMouseMove}>
        <div className={'flag option ' + this.props.option.value} />
      </div>
    );
  }
}
/* eslint-icon */

class IconValue extends Component {
  render() {
    return (
      <div className='Select-value'>
        <span className='Select-value-label'>
          <div className={'flag value ' + this.props.value.value} />
        </span>
      </div>
    );
  }
}

const Language = ({ i18n }) => {
  return (
    <div className='language-container'>
      {
        <Select
          value={i18n.language}
          valueComponent={IconValue}
          options={lngs}
          optionComponent={IconOption}
          onChange={(value) => {
            const lang = value.value || 'it';
            let culture = "c=it-IT|uic=it-IT";
            switch(lang) {
              default:
              case "it":
                culture = "c=it-IT|uic=it-IT";
                break;
              case "en":
                culture = "c=en-US|uic=en-US";
                break;
              case "fr":
                culture = "c=fr-FR|uic=fr-FR";
                break;
            }
            document.cookie = ".AspNetCore.Culture=" + encodeURIComponent(culture) + "; path=/; domain=.dufercoenergia.com; max-age=60*60*24; SameSite=lax";
            i18n.changeLanguage(lang);
          }}
          clearable={false}
          searchable={false}
          placeholder=''
        />
      }
    </div>
  );
};

Language.propTypes = {
  i18n: PropTypes.object
};

export default Language;
